import React, {
  PropsWithChildren,
  ReactNode,
} from 'react';
import isNil from 'lodash/isNil';

type Props = PropsWithChildren & {
  iconSlot?: ReactNode;
};
export default function Empty({
  iconSlot,
  children,
}: Props) {
  return (
    <div className="w-full h-full flex justify-center items-center gap-3 flex-col">
      {!isNil(iconSlot) && (
        <div className="w-16 h-16 rounded-full bg-gray-300 p-4 text-white">
          {iconSlot}
        </div>
      )}
      {children}
    </div>
  );
}
